import { isAfter, isBefore } from "date-fns";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const emptyState = { eventsWithColumns: [], crewLeaders: [] };

/**
 * 
 * @param {*} events 
 * @returns { eventsWithColumns: any[], crewLeaders: any[] }
 */
const useV6CrewLeadersEventColumns = (events) => {
  const resourceWorkers = useSelector((store) => store.schedule.resources.workers);
  
  const state = useMemo(() => {
    const crewLeadersSet = new Set();

    if (!Array.isArray(events) || !events?.length) return emptyState;
  
    // find crew leaders
    events.forEach(event => {
      if (!event.extendedProps?.heightEnd && !event.extendedProps?.heightStart) return;
  
      const sheet = event.extendedProps?.sheet;
      if (!sheet) return;
  
      if (sheet.workers?.some(worker => worker.foreman)) {
        sheet.workers.forEach(worker => worker.foreman && crewLeadersSet.add(worker._id));
      }
    });
  
  
    const clColIndex = {};
    const crewLeaders = Array.from(crewLeadersSet)
      .map((_id) => resourceWorkers.find((w) => w._id === _id))
      .filter(Boolean)
      .sort((a, b) => a?.username.localeCompare(b?.username));
    crewLeaders.forEach((crewLeader, i) => clColIndex[crewLeader._id] = i);
  
    const noClColumns = [{ ranges: [] }];
  
    const eventsWithColumns = events.map(event => {
      const hStart = event.extendedProps?.heightStart;
      const hEnd = event.extendedProps?.heightEnd;
  
      const sheet = event.extendedProps?.sheet;
      if (!sheet) return [];
  
      if (sheet.workers?.some(worker => worker.foreman)) {
        return sheet.workers.filter(worker => worker.foreman).map(worker => {
          const wIndex = crewLeaders.findIndex(cl => cl._id === worker._id);
          return ({
            ...event,
            id: `${event.id}_cl-${worker._id}_col-${wIndex}`,
            extendedProps: {
              ...event.extendedProps,
              column: wIndex
            }
          })
        }).filter(e => !!(~e.extendedProps?.column));
      }
  
      const found = noClColumns.findIndex(col =>
        !col.ranges?.some(range => isBefore(hStart, range.end) && isAfter(hEnd, range.start))
      );
      const column = found === -1 ? noClColumns.length : found;

      if (!noClColumns[column]) noClColumns.push({ ranges: [] });
      noClColumns[column].ranges.push({ start: hStart, end: hEnd });

      return [{
        ...event,
        id: `${event.id}_nocl_col-${column + crewLeaders?.length}`,
        extendedProps: {
          ...event.extendedProps,
          column: column + crewLeaders?.length,
        }
      }]
    }).flat();

    return { eventsWithColumns, crewLeaders };
  }, [events, resourceWorkers])

  return state;
};

export default useV6CrewLeadersEventColumns;